import { getSystemVersion } from './functions.js';

export class Languages {

    constructor() {
        this.declares();
    }

    declares() {
        //
    }

    getSupportedLanguages() {
        return {
            'hu': 'Magyar',
            'en': 'English',
            'pl': 'Polski',
        }
    }

    getSelectedLanguage() {
        //From local storage
        const storedLanguage = localStorage.getItem('_lang');
        const supportedLanguages = this.getSupportedLanguages();

        if (storedLanguage != null && typeof supportedLanguages[storedLanguage] != 'undefined') {
            return storedLanguage;
        }

        if (
            typeof process.env.VUE_APP_I18N_LOCALE != 'undefined'
            && process.env.VUE_APP_I18N_LOCALE != null
            && typeof supportedLanguages[process.env.VUE_APP_I18N_LOCALE] != 'undefined'
            ) {
            return process.env.VUE_APP_I18N_LOCALE;
        }

        const systemVersion = getSystemVersion();
        let defaultLangCode = (['pl'].includes(systemVersion)) ? 'pl' : 'hu';
        /*if (typeof location != 'undefined' && typeof location.hostname != 'undefined' && location.hostname == 'mobileappen.dunahousedev.hu') {
            defaultLangCode = 'en';
        }*/

        return defaultLangCode;
    }

    getSelectedLanguageId() {
        const langCode = this.getSelectedLanguage();

        let languageId = 1;
        switch (langCode) {
            case 'hu':
                languageId = 3;
                break;

            case 'pl':
                languageId = 5;
                break;
        }

        return languageId;
    }

    setLanguage(lang) {
        const supportedLanguages = this.getSupportedLanguages();

        if (typeof supportedLanguages[lang] == 'undefined') {
            return false;
        }

        localStorage.setItem('_lang', lang);
        return true;
    }

}